import React from 'react'
import classes from './SkewArea.module.css';

const SkewArea = () => {
    return (
        <div className={classes.Skew}>
            <div className={classes.container}></div>
        </div>
    )
}

export default SkewArea
